import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle, ForwardedRef } from 'react';
import UserInfo from '../../../interfaces/UserInfo';

interface MentionSuggestionListProps {
  items: UserInfo[];
  command: (item: UserInfo) => void;
}

export interface MentionSuggestionListRef {
  onKeyDown: (props: { event: KeyboardEvent }) => boolean;
}

export const MentionSuggestionList = forwardRef((props: MentionSuggestionListProps, ref: ForwardedRef<MentionSuggestionListRef>) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const selectItem = useCallback((index: number) => {
    const item = props.items[index];
    if (item) {
      props.command(item);
    }
  }, [props]);

  useEffect(() => setSelectedIndex(0), [props.items]);

  useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }) => {
      if (event.key === 'ArrowUp') {
        setSelectedIndex((selectedIndex + props.items.length - 1) % props.items.length);
        return true;
      }
      if (event.key === 'ArrowDown') {
        setSelectedIndex((selectedIndex + 1) % props.items.length);
        return true;
      }
      if (event.key === 'Enter') {
        selectItem(selectedIndex);
        return true;
      }
      return false;
    },
  }));

  return (
    <div className="mention-suggestion-list">
      {props.items.length > 0 ? (
        props.items.map((item, index) => (
          <button
            type="button"
            className={`mention-suggestion-item ${index === selectedIndex ? 'is-selected' : ''}`}
            key={item.id}
            onClick={() => selectItem(index)}
          >
            {item.displayName}
          </button>
        ))
      ) : (
        <div className="mention-suggestion-item">No results</div>
      )}
    </div>
  );
});
